import { render, staticRenderFns } from "./CreateCollect.vue?vue&type=template&id=e9ee9ace&scoped=true&"
import script from "./CreateCollect.vue?vue&type=script&lang=js&"
export * from "./CreateCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ee9ace",
  null
  
)

export default component.exports